/* eslint-disable import/prefer-default-export */
import { getECSDeployLevel } from '../../../utils';

export const getEmbeddedReportServiceUrl = () => {
    const deployLevel = getECSDeployLevel();
    return `https://metabase-signing-service.${deployLevel}.milkmoovement.io/v2/metabase-resources`;
};
